module.exports = __webpack_public_path__ + "static/media/folder-open.2c3a34d4.svg";